module.exports = __webpack_public_path__ + "static/startingstyle4-790578fe4f785e4311d375234cf71f18.mp4";